import { render, staticRenderFns } from "./TestAwardForm.vue?vue&type=template&id=3af88c26"
import script from "./TestAwardForm.vue?vue&type=script&lang=js"
export * from "./TestAwardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af88c26')) {
      api.createRecord('3af88c26', component.options)
    } else {
      api.reload('3af88c26', component.options)
    }
    module.hot.accept("./TestAwardForm.vue?vue&type=template&id=3af88c26", function () {
      api.rerender('3af88c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/test-award/components/TestAwardForm.vue"
export default component.exports